/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/scenario-mapper/scenario-utils',['require','underscore','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  /*****************************************************************************************************************///}

  //var $ = require('jquery');
  var _ = require('underscore');
  //var templates = require('core/templates');
  var Marionette = require('marionette');

  var Scenario;
  require(['screens/scenario-mapper/scenario'], function(a) {
    Scenario = a;
  });
  var ScenarioDialog;
  require(['screens/scenario-mapper/scenario-dialog'], function(a) {
    ScenarioDialog = a;
  });
  var ScenarioVariable;
  require(['screens/scenario-mapper/scenario-variable'], function(a) {
    ScenarioVariable = a;
  });
  //var Scenario = require('screens/scenario-mapper/scenario');
  //var ScenarioActor = require('screens/scenario-mapper/scenario-actor');
  //var ScenarioDialog = require('screens/scenario-mapper/scenario-dialog');
  //var ScenarioVariable = require('screens/scenario-mapper/scenario-variable');
  //var ScenarioLocation = require('screens/scenario-mapper/scenario-location');
  //var ScenarioItem = require('screens/scenario-mapper/scenario-item');

  /*****************************************************************************************************************///}

  var ScenarioUtils = Marionette.Object.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      console.error('DO NOT INSTATIATE');
    }

  /*****************************************************************************************************************///}

  });

  /**
   * Method to determine the conditional value of a string statement
   * @param {string} statement The String statement to evaluate
   * @return Boolean value of what the statement evaluates to
   */
  ScenarioUtils.evaluateConditionalStatement = function(statement)
  {
    //console.warn('evaluate CONDITIONAL statement: ' + statement);
    if (_.trim(statement) === '')
      return true; // no conditional return true

    while (statement.indexOf('(') !== -1)
    {
      statement = ScenarioUtils.replaceParenthetical(statement);
    }

    //var conditionsArr = [];
    var andArr = statement.split(' and ');
    ANDLOOP:
    for (var a = 0; a < andArr.length; a++)
    {
      var loopVal = false;
      var andStr = andArr[a];
      var orArr = andStr.split(' or ');

      if (orArr.length > 0)
      {
        ORLOOP:
        for (var i = 0; i < orArr.length; i++)
        {
          loopVal = ScenarioUtils.evaluateCondition(orArr[i]);
          //console.warn('Condition evaluated to ' + loopVal);
          if (loopVal === true)
            break ORLOOP;
        }
      }
      else
      {
        loopVal = ScenarioUtils.evaluateCondition(andStr);
        //console.warn('Condition evaluated to ' + loopVal);
      }
      if (loopVal === false)
        return false;
    }

    return true;
  };

  /**
   * Method to determine the commands to perform based on script expression
   * @param {string} statement The String script to evaluate
   */
  ScenarioUtils.evaluateScriptStatement = function(statement)
  {
    //console.warn('evaluate SCRIPT statement: ' + statement);
    if (_.trim(statement) === '')
      return; // no conditional return

    var pieceArr = statement.split('&&');
    //var pieceStr;

    var setArr;
    var varStr;
    var valStr;

    _.each(pieceArr, function(pieceStr) {
      setArr = pieceStr.split('=');
      if (setArr.length !== 2)
      {
        console.error('Issue with chat mapper script statement: ' + pieceStr);
        return;
      }
      varStr = _.trim(setArr[0]);
      valStr = _.trim(setArr[1]);

      ScenarioUtils.setValue(varStr, valStr);
    });
    //Scenario.printVarValues();
  };

  ScenarioUtils.findAssetInContainer = function(mcName, container)
  {
    var stageMC;
    var mcNameStr;
    var mcNameArr = mcName.split('.');

    if (!container)
      return null;
    if (container.$el)
      container = container.$el;

    if (mcNameArr.length > 1)
    {
      stageMC = container;
      while (mcNameStr = mcNameArr.shift())
      {
        if (stageMC.find('[data-mc=' + mcNameStr + ']').length > 0)
        {
          stageMC = stageMC.find('[data-mc=' + mcNameStr + ']');
        }
        else
        {
          console.error('Missing hotspot: ' + stageMC + ' -> ' + mcNameStr);
          stageMC = null;
          break;
        }
      }
    }
    else if (container.find('[data-mc=' + mcName + ']').length > 0)
    {
      stageMC = container.find('[data-mc=' + mcName + ']');
    }
    else if (mcName !== 'follow')
    {
      console.error('No background_mc found', mcName);
    }

    return stageMC;
  };

  ScenarioUtils.mcHasLabel = function(mc, label)
  {
    return true;
    // this is no longer needed as a class is applied rather than frame update :BM:
    // var fLabel:FrameLabel;
    // for each (fLabel in mc.currentLabels)
    // {
    //   if (fLabel.name == label)
    //   {
    //     return true;
    //   }
    // }
    // return false;
  };

  /**
   * Method to determine the local value of a given expression or value
   * @param {string} value The data to quantify
   * @return The determined value of the passed expression
   */
  ScenarioUtils.getValue = function(value)
  {
    var dialogID;
    var vName;
    var propArr;
    var propName;

    var vValue;
    var dataObj;

    //console.warn('Quantifying value: ' + value);
    value = _.trim(value);
    if (value === true || value === 'true' || value === 'True')
      return true;
    if (value === false || value === 'false' || value === 'False')
      return false;

    if (isNaN(Number(value)))
    {
      if (value.indexOf(' + ') !== -1)
      {
        return ScenarioUtils.sumValue(value, '+');
      }
      else if (value.indexOf(' - ') !== -1)
      {
        return ScenarioUtils.sumValue(value, '-');
      }
      else if (value.indexOf('Dialog') === 0)
      {
        dialogID = value.substring(value.indexOf('[') + 1, value.indexOf(']'));
        dataObj = ScenarioDialog.getDialogByID(dialogID);
        if (dataObj)
        {
          return dataObj.SimStatus();
        }
        return false;
      }
      else if (value.indexOf('Actor') === 0)
      {
        vName = value.substring(value.indexOf('[\"') + 2, value.indexOf('\"]'));
        if (isNaN(Number(vName)))
        {
          vValue = Scenario.getActorByName(vName);
        }
        else
        {
          vValue = Scenario.getActorByID(vName);
        }
        propArr = value.split('.');
        propName = propArr[1] || null;

        if (vValue && propName) // not null and is var object
        {
          if (propName in vValue)
          {
            vValue = vValue[propName];
          }
          else
          {
            console.error('Attempted to access invalid Actor property: ' + propName);
          }
        }
        //console.warn('Variable value: ' + vValue);
        return vValue;
      }
      else if (value.indexOf('Location') === 0)
      {
        vName = value.substring(value.indexOf('[\"') + 2, value.indexOf('\"]'));
        propArr = value.split('.');
        propName = propArr[1] || null;
        vValue = Scenario.getLocationByName(vName);
        if (vValue && propName) // not null and is var object
        {
          vValue = vValue[propName];
        }
        //console.warn('Variable value: ' + vValue);
        return vValue;
      }
      else if (value.indexOf('Item') === 0)
      {
        vName = value.substring(value.indexOf('[\"') + 2, value.indexOf('\"]'));
        propArr = value.split('.');
        propName = propArr[1] || null;
        vValue = Scenario.getItemByName(vName);
        if (typeof(vValue[propName]) === 'function')
        {
          ////console.log('function found: ', propName);
          vValue = vValue[propName + 'Str'];
        }
        else
        {
          ////console.log('set value: ', value);
          vValue = vValue[propName];
        }
        //console.warn('Variable value: ' + vValue);
        return vValue;
      }
      else if (value.indexOf('Variable') === 0)
      {
        vName = value.substring(value.indexOf('[\"') + 2, value.indexOf('\"]'));
        vValue = Scenario.getVariableByName(vName);
        if (vValue instanceof ScenarioVariable) // not null and is var object
        {
          vValue = vValue.currentValue;
        }
        //console.warn('Variable value: ' + vValue, vName);
        return vValue;
      }
      value = String(value).replace(/\"/g, '');

      return value;
    }
    else
    {
      return Number(value);
    }
  };

  ScenarioUtils.sumValue = function(valueStr, type)
  {
    type = type || '+';

    var valArr = valueStr.split(type);
    var finalVal = ScenarioUtils.getValue(valArr[0]);
    var val;
    var str;

    for (var i = 1; i < valArr.length; i++)
    {
      str = valArr[i];
      val = ScenarioUtils.getValue(str);
      if (val)
      {
        switch (type)
        {
          case '+':
            finalVal += val;
            break;
          case '-':
            finalVal -= val;
            break;
        }
      }
    }

    return finalVal;
  };

  /**
   * Method to evaluate the parenthetical portions of a conditional statement seperately to retain order of operation
   * @param {string} statement The conditional statement to evaluate
   * @return The resulting String statement after parentheticals have been evaluated
   */
  ScenarioUtils.replaceParenthetical = function(statement)
  {
    //console.warn('replacing parenthetical: ' + statement);
    var startIndex = statement.indexOf('(') + 1;
    var endIndex = statement.indexOf(')');

    while (endIndex > statement.indexOf('(', startIndex) && statement.indexOf('(', startIndex) !== -1)
    {
      startIndex = statement.indexOf('(', startIndex) + 1;
    }
    var subStatement = statement.substring(startIndex, endIndex);

    var result = ScenarioUtils.evaluateConditionalStatement(subStatement);

    statement = statement.substring(0, startIndex - 1).concat(result, statement.substring(endIndex + 1));

    return statement;
  };

  /**
   * Evaluates a single conditional operator
   * @param {string} conditionStr The conditional statement to evaluate
   * @return Boolean value of the resulting condition
   */
  ScenarioUtils.evaluateCondition = function(conditionStr)
  {
    //console.warn('evaluating condition: ' + conditionStr);
    if (conditionStr.toLowerCase() === 'true')
      return true;
    if (conditionStr.toLowerCase() === 'false')
      return false;

    var conditionsArr;
    var val1;
    var val2;

    if (conditionStr.indexOf(' == ') !== -1) // equal
    {
      conditionsArr = conditionStr.split(' == ');
      val1 = ScenarioUtils.getValue(conditionsArr[0]);
      val2 = ScenarioUtils.getValue(conditionsArr[1]);
      return (val1 === val2);
    }
    else if (conditionStr.indexOf(' ~= ') !== -1) // not equal
    {
      conditionsArr = conditionStr.split(' ~= ');
      val1 = ScenarioUtils.getValue(conditionsArr[0]);
      val2 = ScenarioUtils.getValue(conditionsArr[1]);
      return (val1 !== val2);
    }
    else if (conditionStr.indexOf(' >= ') !== -1) // greather than or equal
    {
      conditionsArr = conditionStr.split(' >= ');
      val1 = ScenarioUtils.getValue(conditionsArr[0]);
      val2 = ScenarioUtils.getValue(conditionsArr[1]);
      return (val1 >= val2);
    }
    else if (conditionStr.indexOf(' > ') !== -1) // greater than
    {
      conditionsArr = conditionStr.split(' > ');
      val1 = ScenarioUtils.getValue(conditionsArr[0]);
      val2 = ScenarioUtils.getValue(conditionsArr[1]);
      return (val1 > val2);
    }
    else if (conditionStr.indexOf(' <= ') !== -1) // less than or equal
    {
      conditionsArr = conditionStr.split(' <= ');
      val1 = ScenarioUtils.getValue(conditionsArr[0]);
      val2 = ScenarioUtils.getValue(conditionsArr[1]);
      return (val1 <= val2);
    }
    else if (conditionStr.indexOf(' < ') !== -1) // less than
    {
      conditionsArr = conditionStr.split(' < ');
      val1 = ScenarioUtils.getValue(conditionsArr[0]);
      val2 = ScenarioUtils.getValue(conditionsArr[1]);
      return (val1 < val2);
    }
    else
    {
      console.warn('NO IDEA WHAT TO EVAL: ' + conditionStr);
    }

    return false;
  };

  /**
   * Method to set a var value based on expression
   * @param {string} varName The var name expression
   * @param {string} valueStr The passed value expression
   */
  ScenarioUtils.setValue = function(varName, valueStr)
  {
    var value = ScenarioUtils.getValue(valueStr);

    if (varName.indexOf('Method') === 0)
    {
      var methodName = varName.substring(varName.indexOf('[\"') + 2, varName.indexOf('\"]'));
      var methodValue = ScenarioUtils.getValue(varName.substring(varName.indexOf('=')));
      Scenario.singleton.callMethod(methodName, methodValue);
    }
    else if (varName.indexOf('Dialog') === 0)
    {
      var dID = varName.substring(varName.indexOf('[') + 1, varName.indexOf(']'));
      var sd = ScenarioDialog.getDialogByID(dID);
      if (sd)
      {
        console.warn('DIALOG SET VALUE ON: ' + dID, value);
      }
    }
    else if (varName.indexOf('Variable') === 0)
    {
      var vName = varName.substring(varName.indexOf('[\"') + 2, varName.indexOf('\"]'));
      var vValue = Scenario.getVariableByName(vName);
      if (vValue instanceof ScenarioVariable)
      {
        vValue.setValue(value);
      }
    }
    else if (varName.indexOf('Actor') === 0)
    {
      var aName = varName.substring(varName.indexOf('[\"') + 2, varName.indexOf('\"]'));
      var actor;
      if (isNaN(Number(aName)))
      {
        actor = Scenario.getActorByName(aName);
      }
      else
      {
        actor = Scenario.getActorByID(aName);
      }

      var aPropArr = varName.split('.');
      var aPropName = aPropArr[1] || null;

      if (actor && aPropName) // not null and is var object
      {
        actor[aPropName] = value;
      }
      else
      {
        console.error('Actor not found: ' + aName);
      }
    }
    else if (varName.indexOf('Location') === 0)
    {

    }
    else if (varName.indexOf('Item') === 0)
    {
      var iName = varName.substring(varName.indexOf('[\"') + 2, varName.indexOf('\"]'));
      var iPropArr = varName.split('.');
      var iPropName = iPropArr[1] || null;
      var item = Scenario.getItemByName(iName);

      if (item && iPropName) // not null and is var object
      {
        //console.warn('type of item set: ', iPropName, typeof(item[iPropName]));
        if (typeof(item[iPropName]) === 'function')
        {
          ////console.log('call function: ', value);
          item[iPropName](value);
        }
        else
        {
          ////console.log('set value: ', value);
          item[iPropName] = value;
        }
      }
    }
  };

  return ScenarioUtils;

});

